import { render, staticRenderFns } from "./LibraryHistory.vue?vue&type=template&id=5c22bccf&"
import script from "./LibraryHistory.vue?vue&type=script&lang=js&"
export * from "./LibraryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports